import * as React from "react";

import { getEnv } from "../../util";

const env = getEnv(window.location);
const BASE_TITLE = `Volley${env === "production" ? "" : ` - ${env.toUpperCase()[0]}${env.slice(1)}`}`;

const usePageTitle = (parts: string[]) => {
    React.useEffect(() => {
        document.title = `${parts.join(" - ")} | ${BASE_TITLE}`;

        return () => {
            document.title = BASE_TITLE;
        };
    }, [parts]);
};

const PageTitle = ({ parts }: { parts: string[] }) => {
    usePageTitle(parts);
    return null;
};

export default PageTitle;
